import { LoaderSpin, type LoaderSpinProps } from './LoaderSpin.tsx';
import { OnPageLoaderContainer } from './OnPageLoaderContainer.tsx';

export interface LoadingPageBodyProps extends LoaderSpinProps {}

/**
 * Body della Pagina di caricamento generica.
 */
export function LoadingPageBody(props: LoadingPageBodyProps) {
  return (
    // <ResponsiveCard noPadding>
    <OnPageLoaderContainer>
      <LoaderSpin transparent {...props} />
    </OnPageLoaderContainer>
    // </ResponsiveCard>
  );
}
